import * as React from "react";
import FaqConstant from "../../core/constants/FaqConstant";
import useConstructor from "../../core/hooks/useConstructor";
import { Box } from "@material-ui/core";
import { isArrayValid } from "../../helpers/utility";
import FaqModel from "../../core/models/Faq";
import FaqAccordion from "../../components/FaqAccordion";

function Faq() {
  const [isLoading, setLoading] = React.useState(false);
  const [faqs, SetFaqs] = React.useState<FaqModel[]>([]);

  useConstructor(async () => {
    setLoading(true);

    const APIResponse: FaqModel[] = FaqConstant;
    if (isArrayValid(APIResponse)) {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      SetFaqs(APIResponse);
    }

    setLoading(false);
  });

  return <Box mt={3}>{!isLoading && <FaqAccordion faqs={faqs} />}</Box>;
}

export default Faq;
